export default __webpack_public_path__ + "static/media/copy-icon.e9f9fb8e.svg";